/*
 *   File : order-status.js
 *   Author : https://evoqins.com
 *   Description : Broker order status modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Assets
import OrderSuccess from "../../Assets/Images/Modal/order-success.webp";

//Custom components
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton } from '../Buttons';

const OrderStatusModal = (props) => {

    const navigate = useNavigate("");
    const [statusImg, setStatusImg] = useState("");
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");

    useEffect(() => {

        if (props.type === 1) {
            setStatusImg(OrderSuccess);
            setTitle(props.action === "REDEEM" ? "Redemption Success" : "Order Placed Successfully");
            setDescription(props.statusMessage);
        } else if (props.type === 2) {
            setStatusImg(OrderSuccess);
            setTitle(props.action === "REDEEM" ? "Redemption failed" : props.action === "ORDER_SUCCESS" ? "Order Status" : "Order failed");
            setDescription(props.statusMessage);
        }

    }, [props.type]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("order-status-modal-close");
        button.click();
        props.handleClose();
        navigate("/portfolio");
    };

    // handle success
    const _handleSuccess = (type) => {

        if (type === 1) {
            props.handleNavigatePortfolio(props.portfolioId);
        } else {
            props.handleNavigateOrderDetail(props.portfolioId);
        }

        var button = document.getElementById("order-status-modal-close");
        button.click();
    };

    return (
        <div className="modal fade"
            id="order-status-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="order-status-modal"
            aria-hidden="true">

            <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-16 modal-lg px-lg-5`}>
                <span id='order-status-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-16 overflow-hidden border-0 mx-lg-5">
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-end align-items-center pt-3 px-3 pb-0">
                        <Icon icon="close-icon"
                            size="20px"
                            className="cursor-pointer"
                            onPress={_handleCloseModal} />
                    </div>
                    {/* Modal body */}
                    <div className={`modal-body py-0 px-3 px-sm-4 text-center ${props.type === 2 ? "mb-3" : ""} `}>
                        <img src={statusImg}
                            draggable={false}
                            width={200}
                            alt='subscription' />

                        <h4 className='padding-12px-top mb-2 e-text-primary-color e-primary-font-clash-display e-font-18 e-font-weight-500 line-height-22px'>
                            {title}
                        </h4>
                        <p className='px-5 mb-0 e-alt-font-lato e-font-14 e-text-outer-space e-font-weight-400 line-height-20px'>
                            {description}
                        </p>

                        {
                            props.type == 1 ?
                                <>
                                    {/* Action btns */}
                                    <div className="d-flex gap-3 margin-20px-tb">
                                        {
                                            props.portfolioType !== 1 &&
                                            <SecondaryButton name="View Portfolio"
                                                className="flex-fill e-letter-spacing-min-point-1px e-font-16 e-font-14-res w-50"
                                                padding="padding-18px-tb e-padding-8px-tb-res"
                                                onPress={() => _handleSuccess(1)} />
                                        }
                                        <PrimaryButton name="View Order Detail"
                                            padding="padding-18px-tb e-padding-8px-tb-res"
                                            className="flex-fill e-letter-spacing-min-point-1px e-font-16 e-font-14-res w-50"
                                            onPress={() => _handleSuccess(2)} />
                                    </div>
                                </>
                                :
                                <div className="d-flex gap-3 margin-20px-tb">
                                    <SecondaryButton name="View Portfolio"
                                        dismiss="modal"
                                        className="flex-fill e-letter-spacing-min-point-1px e-font-16 e-font-14-res w-100"
                                        padding="padding-18px-tb e-padding-8px-tb-res"
                                        onPress={() => navigate("/portfolio")} />
                                </div>
                        }
                    </div>
                </div>
            </div>
        </div >
    )
}

export default memo(OrderStatusModal);
